'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _EyeSlash = _interopRequireDefault(require('./lib/icons/EyeSlash'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _EyeSlash;
  exports.default = _default;
  module.exports = _default;